(() => {
  const handles = new Set([
    'teas-organic-loose-leaf-tea',
    'tea-pets',
    'handmade-gaiwan',
    'tea-sets-gongfu-tea-ceremony-kit',
    'oolong-tea',
    'yixing-teaware',
  ]);

  const rewriteLinks = () => {
    document.querySelectorAll('.tl-context-commerce__action[href*="/collections/"]').forEach((link) => {
      const rawHref = link.getAttribute('href');
      if (!rawHref) return;

      let url;
      try {
        url = new URL(rawHref, window.location.origin);
      } catch (error) {
        return;
      }

      const match = url.pathname.match(/\/collections\/([^/?#]+)/);
      if (!match || !handles.has(match[1]) || url.searchParams.has('view')) return;

      const currentParams = url.search ? url.search.slice(1) : '';
      url.search = `?view=default${currentParams ? `&${currentParams}` : ''}`;
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteLinks, { once: true });
  } else {
    rewriteLinks();
  }

  document.addEventListener('shopify:section:load', rewriteLinks);
})();
